import { monkeyPatch } from "./monkeyPatch";
import _ from "lodash";

monkeyPatch(Array.prototype, {
  /**
   * removes Elements from Array
   * @param {function} callback (element,index)=>boolean
   * @returns {Array} Array of deleted Elements;
   */
  remove<T>(this: T[], callback: (element: T, index: number, orig: T[]) => boolean): T[] {
    return this.reduceRight((deletedConfigs: T[], element: T, index: number, orig: T[]) => {
      if (callback(element, index, orig)) {
        deletedConfigs.push(orig.splice(index, 1)[0]);
      }
      return deletedConfigs;
    }, []);
  },

  /**
   * wie flatMap, aber ohne null / undefined und jedes Objekt garantiert nur einmal
   * @param {function} callback
   * @returns {Array}
   */
  flatMapUniq<T, U>(
    this: T[],
    callback: (value: T, index: number, array: T[]) => U | ReadonlyArray<U>,
  ): U[] {
    return _.uniq(this.flatMap(callback).filter((x) => x != null));
  },

  /**
   * ein effizientes .map(mapper).find(x=>x)
   * @param {function} mapper
   * @returns {any}
   */
  findMap<T, U>(this: T[], mapper: (v: T) => U | null | undefined): U | undefined {
    for (let v of this) {
      const result = mapper(v);
      if (result != null) {
        return result;
      }
    }
    return undefined;
  },
});
